<template>
  <navbar :color-on-scroll="colorOnScroll"
          :transparent="transparent"
          menu-classes="ml-auto"
          position="fixed"
          type="primary">
    <template slot-scope="{ toggle, isToggled }">
      <router-link class="navbar-brand" to="/">
        <img alt="Running Dinner" src="img/running-dinner-top-gl-rye.svg"/>
      </router-link>
    </template>
    <template slot="navbar-menu">
      <li v-if="status === 'running'" class="nav-item">
        <a class="nav-link btn btn-neutral"
           rel="tooltip"
           target="_blank"
           title="Gå til tilmeldingssiden"
           :href="tilmeldingUrl">
          <p>
            <ticket class="ticket" title="Gå til tilmeldingssiden"/>
            Tilmelding
          </p>
        </a>
      </li>
      <drop-down tag="li" :title="title">
        <nav-link v-for="menuItem in menuItems" :key="menuItem.slug" :to="'/'+menuItem.slug"
                  class="dropdown-item">
          {{ menuItem.title }}
        </nav-link>
      </drop-down>

      <li class="nav-item">
        <a class="nav-link"
           rel="tooltip"
           target="_blank"
           title="Gå til Facebook Begivenhed"
           :href="facebookEventUrl">
          <facebook class="icon-2x" title="Gå til Facebook Begivenhed"/>
          <p class="d-lg-none d-xl-none">Facebook</p>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link"
           data-placement="bottom"
           href="mailto:info@runningdinner.nu"
           rel="tooltip"
           target="_blank"
           title="Send os en email">
          <email class="icon-2x" title="Send os en email"/>
          <p class="d-lg-none d-xl-none">Send os en email</p>
        </a>
      </li>
    </template>
  </navbar>
</template>

<script>
import {DropDown, Navbar, NavbarToggleButton, NavLink} from '@/components';
import {Popover} from 'element-ui';
import {createContentfulClient} from "@/api/ContentfulClient";
import Email from 'vue-material-design-icons/Email'
import Facebook from 'vue-material-design-icons/Facebook'
import Ticket from 'vue-material-design-icons/Ticket'

const client = createContentfulClient();

export default {
  name: 'main-navbar',
  props: {
    transparent: Boolean,
    colorOnScroll: Number
  },
  components: {
    DropDown,
    Navbar,
    NavbarToggleButton,
    NavLink,
    [Popover.name]: Popover,
    Email,
    Facebook,
    Ticket
  },
  data() {
    return {
      title: '',
      menuItems: [],
    }
  },
  computed: {
    facebookEventUrl: function () {
      return this.$store.state.config.facebookEventUrl
    },
    status: function () {
      return this.$store.state.config.status 
    },
    tilmeldingUrl: function () {
      return this.$store.state.config.signupUrl
    }


  },
  created() {
    this.fetchData()
  },
  watch: {
    '$route': 'fetchData'
  },
  methods: {
    async fetchData() {
      this.error = this.post = null;
      this.loading = true;
      const entries = await client.getEntries({
        'content_type': 'menu',
        'fields.slug': 'main_2022',
        'include': 3
      });
      if (entries.total >= 1) {
        this.title = entries.items[0].fields.title;
        this.menuItems = entries.items[0].fields.menuItems.map(menuItem => {
          return {
            title: menuItem.fields.title,
            slug: menuItem.fields.content.fields.slug
          }
        });


      } else if (entries.errors) {
        this.$router.push('/')
      }
    }
  }


};
</script>

<style lang="scss" scoped>
$two: '2.5em';
.material-design-icon.icon-2x {
  height: $two;
  width: $two;
}

.material-design-icon.icon-2x > .material-design-icon__svg {
  height: $two;
  width: $two;
}

.navbar-brand img {
  height: 60px;
}
</style>
